import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../../components/antd/card/CardTitle";
import { CardContent } from "../../components/antd/card/CardContent";
import { FormItemDescription } from "../../components/antd/form/FormItemDescription";
import { FormItemValue } from "../../components/antd/form/FormItemValue";
import { FormItem } from "../../components/antd/form/FormItem";
import { FormLabel } from "../../components/antd/form/FormLabel";
import { useAppSelector } from "../../store/hooks";
import { useCpFormValue } from "../gvc/testNewForm/utils";
import { CpFormItem } from "../gvc/testNewForm/CpFormItem";
import { CpSwitch } from "../gvc/testNewForm/CpSwitch";
import { CpLabel } from "../gvc/testNewForm/CpLabel";
import { CpDescription } from "../gvc/testNewForm/CpDescription";
import { CpSelect } from "../gvc/testNewForm/CpSelect";
import { CpLabelTooltip } from "../gvc/testNewForm/CpLabelTooltip";
import { CpTooltip } from "../gvc/testNewForm/CpTooltip";

interface Props {}
export const AuthConfig: React.FC<Props> = ({}) => {
  const isUserSaml = useAppSelector((state) => state.user.isSaml);

  const samlOnly = useCpFormValue(`authConfig.samlOnly`);
  const domainAutoMembers = useCpFormValue(`authConfig.domainAutoMembers`);

  const isSaml = useCpFormValue(`authConfig.isSaml`);
  const samlDomain = useCpFormValue(`authConfig.samlDomain`);

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            <div>Auth Config</div>
            <CpDescription>These settings can only be changed by signing in with a SAML provider.</CpDescription>
          </CardTitle>
          {!isUserSaml ? (
            <CardContent>
              <FormItem>
                <FormLabel>SAML Only</FormLabel>
                <FormItemDescription>Allows users to only sign in with Saml.</FormItemDescription>
                <FormItemValue>{samlOnly ? "Yes" : "No"}</FormItemValue>
              </FormItem>
              <FormItem lastItem>
                <FormLabel>Domain Auto Members</FormLabel>
                <FormItemValue>{domainAutoMembers === "self" ? samlDomain : "None"}</FormItemValue>
              </FormItem>
            </CardContent>
          ) : (
            <>
              <CardContent>
                <CpFormItem>
                  <div className="flex items-center gap-2">
                    <CpLabelTooltip>
                      <CpLabel name={`authConfig.samlOnly`}>SAML Only</CpLabel>
                      <CpTooltip tooltipProps={{ title: `Allows users to only sign in with Saml` }} />
                    </CpLabelTooltip>
                    <CpSwitch name={`authConfig.samlOnly`} />
                  </div>
                </CpFormItem>
                {isSaml ? (
                  <CpFormItem>
                    <CpLabel name={`authConfig.domainAutoMembers`}>Domain Auto Members</CpLabel>
                    <CpSelect
                      name={`authConfig.domainAutoMembers`}
                      options={
                        samlDomain
                          ? [
                              { label: "None", value: "none" },
                              { label: samlDomain, value: "self" },
                            ]
                          : [{ label: "None", value: "none" }]
                      }
                      style={{ width: 600 }}
                    />
                  </CpFormItem>
                ) : (
                  <FormItem lastItem>
                    <FormLabel>Domain Auto Members</FormLabel>
                    <FormItemValue>{domainAutoMembers === "self" ? samlDomain : "None"}</FormItemValue>
                  </FormItem>
                )}
              </CardContent>
            </>
          )}
        </Card>
      </div>
    </>
  );
};
